angular.module('boc')
  .value('setWhile', function(obj, prop, fn) {
    return function() {
      var promise = fn.apply(null, arguments)
      if (!promise || !promise.finally) return
      obj[prop] = true
      promise.finally(function() { obj[prop] = false })
    }
  })
